import { Modal, Table, TableColumnType, Typography } from "antd";
import { Link } from "react-router-dom";
import { IPurchaseOrder } from "../../models/Purchase";
import { useGetPurchaseOrderByPurchaseRequest } from "../../query/PurchaseQuery";
interface IModalViewPurchaseOrder {
  purchaseRequestId: number;
  open: boolean;
  onClose: () => void;
}
const ModalViewPurchaseOrder = ({
  purchaseRequestId,
  open,
  onClose,
}: IModalViewPurchaseOrder) => {
  const { data, isLoading } =
    useGetPurchaseOrderByPurchaseRequest(purchaseRequestId);

  const column: TableColumnType<IPurchaseOrder>[] = [
    {
      title: "Mã mua hàng",
      dataIndex: "pONumber",
      key: "pONumber",
    },
    {
      title: "Ngày đặt hàng",
      dataIndex: "orderDate",
      key: "orderDate",
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      render(value) {
        switch (value) {
          case "DRAFT":
            return <span className="text-yellow-500">Đang xử lý</span>;
          case "SENT":
            return <span className="text-blue-500">Đã gửi</span>;
          case "PARTIALLY_RECEIVED":
            return <span className="text-orange-500">Đã nhận một phần</span>;
          case "COMPLETED":
            return <span className="text-green-500">Đã đóng - Hoàn thành</span>;
          default:
            return <span>{value}</span>;
        }
      },
    },
    {
      title: "Action",
      dataIndex: "view",
      key: "view",
      render: (value, record) => (
        <Link to={`/purchase/orders/${record.pONumber}`}>
          <Typography.Text style={{ color: "green" }}>Xem</Typography.Text>
        </Link>
      ),
    },
  ];
  return (
    <Modal className="p-4" open={open} onCancel={onClose} footer={null}>
      <Table
        dataSource={data}
        columns={column}
        loading={isLoading}
        locale={{
          emptyText: "Yêu cầu này chưa tạo đơn hàng",
        }}
      />
    </Modal>
  );
};

export default ModalViewPurchaseOrder;
